module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading1 || _vm.isLoading2),
      expression: "isLoading1 || isLoading2"
    }],
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('div', {
    staticClass: "warpper"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("好近小店二维码")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "30px 0"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "180px 12% 0 8%"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-form', {
    ref: "tabelForm",
    attrs: {
      "label-position": "top",
      "label-width": "80px",
      "model": _vm.tabelForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "桌牌数量"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "endNum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入生成桌牌的数量"
    },
    model: {
      value: (_vm.tabelForm.endNum),
      callback: function($$v) {
        _vm.$set(_vm.tabelForm, "endNum", _vm._n($$v))
      },
      expression: "tabelForm.endNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("请填写纯数字")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.createBtnDisabled
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('tabelForm')
      }
    }
  }, [_vm._v("生成二维码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.resetDisabled
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "border-left": "1px solid #e7eaec",
      "padding": "0 60px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('figure', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPreview),
      expression: "isPreview"
    }]
  }, [_c('img', {
    staticClass: "pic-preview",
    attrs: {
      "src": require("./img/qrcode-demo.png"),
      "alt": "二维码预览"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_vm._v("二维码预览")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    staticClass: "realQrcode"
  }, [_c('figure', {
    attrs: {
      "id": "tablePreview"
    }
  }, [_c('canvas', {
    attrs: {
      "width": "350",
      "height": "455"
    }
  }), _vm._v(" "), _c('p', [_vm._v("已生成"), _c('em', [_vm._v(_vm._s(_vm.tabelForm.endNum))]), _vm._v("个桌贴")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.downloadTabelBtnDisabled
    },
    on: {
      "click": function($event) {
        return _vm.downloadTabel()
      }
    }
  }, [_vm._v("下载桌贴")])], 1), _vm._v(" "), _c('figure', {
    attrs: {
      "id": "qrcodePreview"
    }
  }, [_c('canvas', {
    attrs: {
      "width": "350",
      "height": "455"
    }
  }), _vm._v(" "), _c('p', [_vm._v("已生成"), _c('em', [_vm._v(_vm._s(_vm.tabelForm.endNum))]), _vm._v("个二维码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.downloadQrcodeBtnDisabled
    },
    on: {
      "click": function($event) {
        return _vm.downloadQrcode()
      }
    }
  }, [_vm._v("下载二维码")])], 1)])])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bg",
      "src": require("./img/bg.jpg"),
      "alt": "点餐桌贴"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tableQrcodeContainer"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "qrcodeContainer"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("输入桌牌信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-281d73d5"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/qrcode/qrcode.vue
// module id = 818
// module chunks = 0